import {MultilingualText} from "@/i18n/MultilingualText";

export type SlideTransition = GoToTransition | ChoiceTransition | EndOfTutorial | StatefulSlideTransition;

export interface GoToTransition {
    type: TransitionType.GoTo;
    id: string;
    isBackward: boolean;
}

export interface ChoiceTransition {
    type: TransitionType.Choice;
    choices: ChoiceData[];
}

export interface ChoiceData {
    id: string;
    isBackward: boolean;
    text: MultilingualText;
}

export interface StatefulSlideTransition {
    type: TransitionType.Stateful;
    rules: TransitionRule[];
}

export interface TransitionRule {
    id: string;
    isBackward: boolean;
    expr: string;
}

export interface EndOfTutorial {
    type: TransitionType.EndOfTutorial
}

export enum TransitionType {
    EndOfTutorial = 0,
    GoTo = 1,
    Choice = 2,
    Stateful = 3
}

export enum CriterionType {
    State = 1,
    Score = 2
}